module.exports = __webpack_public_path__ + "img/background_sky.de53ce2b.svg";